import DiagnosticsListView from '../common/DiagnosticsListView'
import { CXRAY_LIST_CONFIG } from '../common/configs'

const CxrayListPage = () => <DiagnosticsListView config={CXRAY_LIST_CONFIG} />

export default CxrayListPage
